import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import format from 'date-fns/format';
import * as locale from 'date-fns/esm/locale';
import { DomSanitizer } from '@angular/platform-browser';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
// import { PmsbookinitService } from 'modules/onecart/projects/shared/services/pmsbookinit.service';

@Pipe({
  name: 'momentPipeDateTime',
})
export class momentPipeDateTime implements PipeTransform {
  transform(date: any, dateFunctionConfig?: any): any {
    if (date != '') {
      return format(new Date(moment(date).toDate()), dateFunctionConfig.dateMediumFormat + ' ' + dateFunctionConfig.timeFormat, {
        locale: locale[dateFunctionConfig.locale],
      });
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'seatMomentPipeDateTime',
})
export class seatMomentPipeDateTime implements PipeTransform {
  transform(date: any, dateFunctionConfig?: any): any {
    if (date != '') {
      return format(new Date(moment(date).toDate()), dateFunctionConfig.dateFormat + ' - ' + dateFunctionConfig.timeFormat, {
        locale: locale[dateFunctionConfig.locale],
      });
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'momentPipeDate',
})
export class momentPipeDate implements PipeTransform {
  transform(date: any, dateFunctionConfig?: any): any {
    if (date != '') {
      return format(new Date(moment(date).toDate()), dateFunctionConfig.dateMediumFormat, { locale: locale[dateFunctionConfig.locale] });
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'momentPipeDateChange',
})
export class MomentPipeDateChange implements PipeTransform {
  transform(date: string, countryCode?: string, dateFunctionConfig?: string): string {
    if (date != '') {
      const dates = new Date(date); // Get the current date
      let dateOptionsShort = {
        year: 'numeric',
        month: dateFunctionConfig['monthNameFormat'] == 'MMMM' ? 'long' : 'short',
        day: '2-digit',
      } as const;
      const formatter = new Intl.DateTimeFormat(countryCode, dateOptionsShort);
      const formattedDate = formatter.format(dates); // Output: "Jun 13, 2023"
      if (countryCode == 'EN' || countryCode == 'en-US' || countryCode == 'en-GB') {
        return format(moment(date, 'YYYY-MM-DD').toDate(), dateFunctionConfig['dateMediumFormat'], {
          locale: locale[dateFunctionConfig['locale']],
        });
      } else {
        return formattedDate;
      }
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'multiLangDatePipe',
})
export class MultiLangDatePipe implements PipeTransform {
  transform(date: string, countryCode?: string, dateFunctionConfig?: string): string {
    if (date != '') {
      let month = dateFunctionConfig['dateMediumFormat'].match(/M/g) || [].length;
      let weekday = dateFunctionConfig['dateMediumFormat'].match(/E/g) || [].length;
      const dates = new Date(moment(date).toDate());
      let dateOptionsShort = {
        year: 'numeric',
        month: month.length >= 4 ? 'long' : 'short',
        day: '2-digit',
      } as const;
      if (weekday) {
        dateOptionsShort['weekday'] = weekday.length >= 4 ? 'long' : 'short';
      }
      const formatter = new Intl.DateTimeFormat(countryCode, dateOptionsShort);
      const formattedDate = formatter.format(dates);
      return formattedDate;
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'roomorder',
})
export class RoomOrder implements PipeTransform {
  transform(value: any[], permission): any[] {
    if (permission)
      return value.sort(function (x, y) {
        return x['hasComp'] === y['hasComp'] ? 0 : x['hasComp'] && !x['blockRoom'] ? -1 : 1;
      });
    else return value;
  }
}
@Pipe({
  name: 'custTime',
})
export class CustTimePipe implements PipeTransform {
  transform(time: any, dateFunctionConfig?: any, inputformat?: any): any {
    // !inputformat ? (inputformat = 'hh:mm') : inputformat;
    if (!inputformat) {
      inputformat = 'hh:mm';
    }
    return format(new Date(moment(time, inputformat).toDate()), dateFunctionConfig.timeFormat, {
      locale: locale[dateFunctionConfig.locale],
    });
  }
}

@Pipe({
  name: 'implode',
})
export class ImplodePipe implements PipeTransform {
  transform(elements: string[]): any {
    return elements.join(', ').replace(/, ([^,]*)$/, ' & $1');
  }
}

@Pipe({
  name: 'custTimeChange',
})
export class CustTimePipeChange implements PipeTransform {
  transform(time: any, countryCode?: any, inputformat?: any): any {
    let timeFormat = moment(time, 'hh:mm A').format('HH:mm');
    const timeString = new Date(moment(timeFormat, inputformat).toDate());
    return new Intl.DateTimeFormat(countryCode, {
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: inputformat === 'hh:mm a' ? 'h12' : 'h23',
    }).format(timeString);
  }
}

@Pipe({
  name: 'seatTime',
})
export class SeatTimePipe implements PipeTransform {
  transform(time: any, dateFunctionConfig?: any, date?: any): any {
    // console.log("input format",inputformat)
    if (date) {
      date = moment(date).format('YYYY-MM-DD');
      return format(new Date(date + 'T' + time), dateFunctionConfig.timeFormat, { locale: locale[dateFunctionConfig.locale] });
    } else {
      return new Date(time).toLocaleTimeString(dateFunctionConfig.locale, {
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: dateFunctionConfig.timeFormat === 'hh:mm a' ? 'h12' : 'h23',
      });
    }
  }
}

@Pipe({
  name: 'activityTimeFormat',
})
export class ActivityTimeFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // Remove milliseconds and split time
    const timeWithoutMilliseconds = value.split('.')[0]; // Remove milliseconds if present
    const [hours, minutes] = timeWithoutMilliseconds.split(':').map(Number);

    let period = 'AM';
    if (hours >= 12) {
      period = 'PM';
    }

    const hour12Format = hours % 12 || 12;

    return `${hour12Format}:${this.padWithZero(minutes)} ${period}`;
  }

  private padWithZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }
}

@Pipe({
  name: 'getDay',
})
export class GetDayPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    let newArr = [];
    let rplc = value.map((days) => {
      if (days.key != 'id' && days.key != 'serviceId' && days.key != 'typeName' && !days.value) {
        newArr.push(days.key.replace('isAvailableOn', ''));
      }
      return days;
    });
    let weekdays: any = [0, 1, 2, 3, 4, 5, 6].map((dow) => moment().locale('en-US').weekday(dow).format('dddd'));
    let finalArray = [];
    weekdays.forEach((e1) =>
      newArr.forEach((e2) => {
        if (e1 === e2) {
          finalArray.push(e1);
        }
      })
    );
    return finalArray;
  }
}

@Pipe({
  name: 'checkDate',
})
export class checkDate implements PipeTransform {
  transform(startDate: any, endDate: any): any {
    if (startDate != '' && endDate != '') {
      let startingDate = new Date(startDate.split('-')[0], startDate.split('-')[1], startDate.split('-')[2]);
      let endingDate = new Date(endDate.split('-')[0], endDate.split('-')[1], endDate.split('-')[2]);
      return startingDate.valueOf() === endingDate.valueOf();
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'custTimeGroup',
})
export class custTimeGroup implements PipeTransform {
  transform(date: any, dateFunctionConfig?: any): any {
    if (date != '') {
      let splitByHypen = date.split('-');
      let TimePart = splitByHypen[3].split('.');
      let dateTime = `${splitByHypen[0]}-${splitByHypen[1]}-${splitByHypen[2]} ${TimePart[0]}:${TimePart[1]}:${TimePart[2]}`;
      return format(new Date(moment(dateTime).toDate()), dateFunctionConfig.timeFormat, { locale: locale[dateFunctionConfig.locale] });
    } else {
      return '';
    }
  }
}

@Pipe({ name: 'safeHtml', pure: false })
export class EscapeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(content) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@Pipe({
  name: 'therapistName',
})
export class TherapistNamePipe implements PipeTransform {
  transform(therapist: any, displayType?: any, reference?: any): any {
    let displystr;
    switch (displayType) {
      case reference.verifyName:
        displystr = therapist.firstName + ' ' + therapist.lastName;
        break;
      case reference.verifyCode:
        displystr = therapist?.code;
        break;
      case reference.verifyaka:
        displystr = therapist.alsoKnownAs ? therapist.alsoKnownAs : therapist.gender;
        break;
      default:
        displystr = therapist.firstName + ' ' + therapist.lastName;
    }
    return displystr;
  }
}

@Pipe({
  name: 'serviceFilter',
})
export class SpaServiceFilter implements PipeTransform {
  transform(service: any, selected: any, showall: any, minLength: any) {
    if (!service) {
      return [];
    }
    if (selected) {
      return service;
    }
    if (!showall) {
      return service.slice(0, minLength);
    } else {
      return service;
    }
  }
}

@Pipe({
  name: 'chunkService',
})
export class ChunkService implements PipeTransform {
  transform(item: any, chunkSize: any) {
    return [].concat.apply(
      [],
      item.map(function (elem, i) {
        return i % chunkSize ? [] : [item.slice(i, i + chunkSize)];
      })
    );
  }
}

@Pipe({
  name: 'serviceGroupFilter',
})
export class ServiceGroupFilter implements PipeTransform {
  transform(serviceGroup: any, serviceName: any) {
    console.log('type foof', typeof serviceName);
    let item = JSON.parse(JSON.stringify(serviceGroup));
    if (typeof serviceName != 'string') {
      return item;
    }
    if (!serviceName) {
      return item;
    }
    return item.filter((sgroup) => {
      let sfilterarr = sgroup.services.filter((service) => service.description.toLowerCase().indexOf(serviceName.toLowerCase()) === 0);
      if (sfilterarr.length) {
        sgroup.services = sfilterarr;
        return true;
      } else {
        return false;
      }
    });
  }
}

@Pipe({
  name: 'checkObjEmpty',
})
export class checkObjEmpty implements PipeTransform {
  transform(guestDetails: any, randomNumber: number): any {
    let fields = ['title', 'firstName', 'lastName', 'email', 'phoneNumber', 'address', 'city', 'state', 'country', 'zipCode'];
    guestDetails.forEach((ele, ind) => {
      let results = fields.map((element) => {
        if (guestDetails[ind][element] && guestDetails[ind][element].trim().length > 0) {
          return true;
        } else {
          return false;
        }
      });
      let newResult = results.some((val) => val === true);
      guestDetails[ind]['isEmpty'] = !newResult;
    });
    // console.log(guestDetails,'guestDetails')
    return guestDetails;
  }
}

@Pipe({ name: 'groupByProduct' })
export class GroupByProductPipe implements PipeTransform {
  transform(collection, property: string, count?: number) {
    // prevents the application from breaking if the array of objects doesn't exist yet
    if (!collection) {
      return null;
    }

    if (collection && collection.length > 0 && collection[0].hasOwnProperty('meta')) {
      collection[0] = collection[0].meta;
      collection = collection.map((dt) => {
        let rep;
        if (dt.hasOwnProperty('meta')) {
          rep = dt['meta'];
        } else rep = dt;
        return rep;
      });
    }
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property].toLowerCase()]) {
        if (
          (current[property] && current[property].toLowerCase().includes('lms')) ||
          current[property].toLowerCase().includes('stay') ||
          current[property].toLowerCase().includes('v1')
        ) {
          if (current.activityName != 'unit') {
            if (!previous['wbe']) {
              previous['wbe'] = [current];
            } else {
              previous['wbe'].push(current);
            }
          } else {
            if (!previous['unit']) {
              previous['unit'] = [current];
            } else {
              previous['unit'].push(current);
            }
          }
        } else {
          previous[current[property].toLowerCase()] = [current];
        }
      } else {
        previous[current[property].toLowerCase()].push(current);
      }
      return previous;
    }, {});
    // this will return an array of objects, each object containing a group of objects
    return Object.keys(groupedCollection).map((key) => ({ key, value: groupedCollection[key] }));
  }
}

@Pipe({ name: 'groupByDate' })
export class GroupByDatePipe implements PipeTransform {
  transform(collection, property: string) {
    // prevents the application from breaking if the array of objects doesn't exist yet
    if (!collection) {
      return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
      let date = moment(current[property]).format('YYYY-MM-DD');
      if (!previous[date]) {
        previous[date] = [current];
      } else {
        previous[date].push(current);
      }
      return previous;
    }, {});

    // this will return an array of objects, each object containing a group of objects
    return Object.keys(groupedCollection).map((key) => ({ key, value: groupedCollection[key] }));
  }
}

@Pipe({ name: 'nightsBetween' })
export class NightsBetweenPipe implements PipeTransform {
  transform(collection, startDate: string, endDate: string) {
    if (startDate.split('T')[0] === endDate.split('T')[0]) {
      return 0;
    }
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(startDate);
    const secondDate = new Date(endDate);

    const diffDays = secondDate.getTime() - firstDate.getTime();

    return Math.ceil(diffDays / oneDay);
  }
}

@Pipe({ name: 'durationBetween' })
export class DurationBetweenPipe implements PipeTransform {
  transform(collection, startDate: string, endDate: string, timeFormat: string) {
    if (timeFormat === 'hour') {
      const oneHour = 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(startDate);
      const secondDate = new Date(endDate);

      const diffHours = secondDate.getTime() - firstDate.getTime();

      return Number(diffHours / oneHour).toFixed(2);
    } else if (timeFormat === 'min') {
      const oneMin = 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(startDate);
      const secondDate = new Date(endDate);

      const diffMins = secondDate.getTime() - firstDate.getTime();

      return Math.round(diffMins / oneMin);
    }
  }
}

@Pipe({ name: 'groupByActivityAndType' })
export class ActivityAndCartItemsPipe implements PipeTransform {
  transform(collection, property: string) {
    // prevents the application from breaking if the array of objects doesn't exist yet
    if (!collection) {
      return null;
    }

    if (collection && collection.length > 0 && collection[0].hasOwnProperty('meta')) {
      collection[0] = collection[0].meta;
      collection = collection.map((dt) => {
        let rep;
        if (dt.hasOwnProperty('meta')) {
          rep = dt['meta'];
        } else rep = dt;
        return rep;
      });
    }
    let groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current['elementType']]) {
        previous[current['elementType']] = {};
      }
      if (!previous['soldOut']) {
        previous['soldOut'] = {};
      }
      if (!previous['cancelled']) {
        previous['cancelled'] = {};
      }

      if (current['cancelled']) {
        let prop = current[property].toLowerCase();
        if (
          (current[property] && current[property].toLowerCase().includes('lms')) ||
          current[property].toLowerCase().includes('stay') ||
          current[property].toLowerCase().includes('v1')
        ) {
          prop = 'wbe';
        }
        if (previous['cancelled'][prop]?.length) {
          previous['cancelled'][prop].push(current);
        } else {
          previous['cancelled'][prop] = [current];
        }
      } else if (current['soldOut']) {
        if (previous['soldOut'][current[property].toLowerCase()]?.length) {
          previous['soldOut'][current[property].toLowerCase()].push(current);
        } else {
          previous['soldOut'][current[property].toLowerCase()] = [current];
        }
      } else {
        if (!previous[current['elementType']][current[property].toLowerCase()]) {
          if (
            (current[property] && current[property].toLowerCase().includes('lms')) ||
            current[property].toLowerCase().includes('stay') ||
            current[property].toLowerCase().includes('v1')
          ) {
            if (current.activityName != 'unit') {
              if (!previous[current['elementType']]['wbe']) {
                previous[current['elementType']]['wbe'] = [current];
              } else {
                previous[current['elementType']]['wbe'].push(current);
              }
            } else {
              if (!previous[current['elementType']]['unit']) {
                previous[current['elementType']]['unit'] = [current];
              } else {
                previous[current['elementType']]['unit'].push(current);
              }
            }
          } else {
            previous[current['elementType']][current[property].toLowerCase()] = [current];
          }
        } else {
          previous[current['elementType']][current[property].toLowerCase()].push(current);
        }
      }

      return previous;
    }, {});
    let finalCollection = {};
    if (groupedCollection)
      for (collection in groupedCollection) {
        finalCollection[collection] = Object.keys(groupedCollection[collection]).map((key) => ({
          key,
          value: groupedCollection[collection][key],
        }));
      }
    let returnCollection = Object.keys(finalCollection).map((key) => ({ key, value: finalCollection[key] }));
    console.log('Pipe: ', groupedCollection, finalCollection, returnCollection);
    // this will return an array of objects, each object containing a group of objects
    return returnCollection;
  }
}

@Pipe({
  name: 'secondsTransform',
})
export class SecondsTransformPipe implements PipeTransform {
  constructor() {}

  transform(value: number): string {
    if (value === 0) {
      return String(value);
    }

    let minutes: number = Math.trunc(value / 60);
    let hours: number = 0;
    let seconds: number = value - minutes * 60;

    if (minutes >= 60) {
      hours = Math.trunc(minutes / 60);
      minutes = minutes - hours * 60;
    }

    let response: string = '';

    if (hours > 0) {
      response = response + hours + ' hrs ';
    }

    if (minutes > 0) {
      response = response + minutes + ' mins ';
    }

    if (seconds > 0) {
      seconds = +Math.round(seconds);
      response = response + seconds + ' secs';
    }

    return response;
  }
}

@Pipe({
  name: 'calculateStartingFromRate',
})
export class CalculateStartingFromRate implements PipeTransform {
  constructor() {}

  transform(value, isResortFeeAddedToRoomTotal) {
    let startRate = 0;
    let minRate = value.minRate;
    let minResortFee = 0;
    let allDaysResortFee = [];
    if (isResortFeeAddedToRoomTotal) {
      value?.rateSnapshot?.forEach((perDay) => {
        let resortFeePerDay = 0;
        perDay.recurringCharges.forEach((element) => {
          if (element.isResortFee) {
            resortFeePerDay += element.recurringCharge;
          }
        });
        allDaysResortFee.push(resortFeePerDay);
      });
      if (allDaysResortFee.length) {
        minResortFee = Math.min(...allDaysResortFee);
      }
    }
    startRate = minRate + minResortFee;

    return startRate;
  }
}

@Pipe({
  name: 'calTotalPriceByKey',
})
export class CalcTotalPriceByKey implements PipeTransform {
  transform(value, key) {
    let sum = 0;
    if (value && value.length) {
      value.forEach((element) => {
        sum += element[key];
      });
    }
    return sum;
  }
}

@Pipe({
  name: 'checkForAddedItem',
})
export class CheckForAddedItem implements PipeTransform {
  transform(value, action?: boolean) {
    if (!value) {
      return;
    }
    let displayDot = false;
    let selectedCount = 0;
    value.forEach((enhancement) => {
      if (enhancement.selected == 'Y') {
        displayDot = true;
        selectedCount++;
      }
    });
    return [{ displayValue: displayDot, count: selectedCount }];
  }
}

@Pipe({
  name: 'guestCountBasedRate',
})
export class GuestCountBasedRate implements PipeTransform {
  constructor(public appInit: LegacyBookInitService) {}

  transform(value, countData?: any) {
    let rate = value?.['rate'] ? value?.['rate'] : 0;
    if (!rate) {
      rate = 0;
    }
    if (countData && this.appInit?.PropertyData?.permissions?.functionalPermissions?.displayGuestCountInOfferandCalendarPage) {
      for (let object of Object.keys(countData)) {
        switch (object) {
          case 'adults':
            // adultsIncluded values is re calculated as Stay sends min rate with 1 adult already added
            rate = this.calculateRateBasedOnGuest(rate, countData, object, value['adultsIncluded'], value['additionalAdultRate']);
            break;
          case 'children':
            rate = this.calculateRateBasedOnGuest(rate, countData, object, value['childrenIncluded'], value['additionalChildRate']);
            break;
          case 'juniors':
            rate = this.calculateRateBasedOnGuest(rate, countData, object, value['juniorsIncluded'], value['additionalJuniorRate']);
            break;
          case 'infants':
            rate = this.calculateRateBasedOnGuest(rate, countData, object, value['infantsIncluded'], value['additionalInfantRate']);
            break;
          case 'discChild':
            rate = this.calculateRateBasedOnGuest(rate, countData, object, value['discchildIncluded'], value['additionalDiscChildRate']);
            break;

          default:
            break;
        }
      }
    }
    return rate;
  }

  calculateRateBasedOnGuest(rate: number, countData: Object, guestType: string, included: number, additionalRate: number) {
    if (countData.hasOwnProperty(guestType)) {
      if (included) {
        rate = rate + (included >= Number(countData[guestType]) ? 0 : (Number(countData[guestType]) - included) * (additionalRate || 0));
      } else {
        rate = rate + (additionalRate ? Number(countData[guestType]) * additionalRate : 0);
      }
    }
    return rate || 0;
  }
}
